import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = { 'baseUrl': { type: String, default: '' },
                    'dateParamName': { type: String, default: 'date' } }

  inputTargetConnected(target) {
    const config = {
      enableTime: false,
      dateFormat: 'd/m/Y',
      disableMobile: true,
      locale: {
        firstDayOfWeek: 1
      }
    }

    if(this.baseUrlValue && this.baseUrlValue != '' && this.dateParamNameValue && this.dateParamNameValue != '') {
      const context = this

      config.onChange = function(_selectedDates, dateStr, _instance) {
        let [d,m,y] = dateStr.split('/')
        const dateStrFormatted = `${y}-${m}-${d}`

        let url = new URL(context.baseUrlValue)

        url.searchParams.set(context.dateParamNameValue, dateStrFormatted)
        window.location = url.toString()
      }
    }

    flatpickr(target, config)
  }
}
